exports.PostsMetaInfo = {
  AAPResponse: {
    title: 'American Academy of Pediatrics Study Unwittingly Validates "Four Pillars of Safe Breastmilk Sharing"',
    description: 'Community-based milksharing versus buying milk online.'
  },
  CAPPApost: {
    title: 'What do CMAJ, Midwifery Today, Pubmed and CAPPA have to do with Eats on Feets?',
    description: 'Eats on Feets helps shape human milksharing policies on a community level.'
  },
  CMJResponse: {
    title: 'Response to Canadian Medical Association Journal',
    description: 'A response to the original article published in the Canadian Medical Association Journal "Milk sharing: boon or biohazard?"'
  },
  HowToRunAnEofPage: {
    title: 'How To Run An Eats on Feets Chapter Page',
    description: 'Volunteer on our network to help support community-based human milk sharing.'
  },
  ProfitingOffOfBreastMilk: {
    title: 'Profiting off of Breastmilk',
    description: 'Critiques on outdated milk bank models and the affordability of community-based milksharing.'
  },
  MidwiferyTodayArticle: {
    title: 'Midwifery Today Article',
    description: 'Shell Walker Luttrell and Maria Armstrong contributed a major article to the 2012 Spring edition of Midwifery Today reflecting their research into the safe handling and sharing of breastmilk.'
  },
  ProtectingPams: {
    title: 'Protecting PAMS Participants\' Privacy',
    description: 'Group Asks Participants to Share Private Information'
  },
  DonorBreastmilkPartOne: {
    title: 'Donor Breastmilk: Part One - A real account on how I met my first donor',
    description: 'Personal milksharing story'
  },
  MooreSalasInterview: {
    title: 'An interview with Kimberly Moore-Salas, Diné Nation',
    description: 'In honor of Native Breastfeeding Week (August 9-15)'
  },
  MuhammadPonceInterview: {
    title: 'An interview with Lakisa Muhammad, Midwife, Educator and Michelle Ivette Ponce, Traditional Healer, Community Organizer and Performance Artist',
    description: 'In honor of Black Breastfeeding Week (August 25-31)'
  },
  AreYouBeingScammed: {
    title: 'Are You Being Scammed?',
    description: 'Some things you can do to avoid being scammed.'
  },
  TanishaMissouriVolunteer: {
    title: 'Tanisha\'s Story',
    description: 'Tanisha\'s milksharing story'
  },
  SellingBuyingBartering: {
    title: 'Selling, Buying, and Bartering',
    description: 'What is the issue with bartering human milk for pump parts?'
  },
  Kara: {
    title: 'Kara\'s Milksharing Story',
    description: 'From recipient to donor.'
  },
  InfantFormulaShortage: {
    title: 'Infant Formula Shortage',
    description: 'Answers to media questions'
  }
}
